import {createSlice, createAsyncThunk} from '@reduxjs/toolkit'
import {
  onGetPagedAllUniversities,
  onCreateUniversity,
  onDeleteUniversity,
  onGetUniversity,
  onUpdateUniversity,
} from '../../../app/modules/system-definitions/components/universities/core/_requests'
import {onGetUniversityTypes} from '../../../app/services/dataForComboBox/dataForComboBoxService'
interface UniversityState {
  universities: any
  university: any
  universityTypes: any
  isLoading: boolean
}
const initialState = {
  universities: [],
  universityTypes: [],
  university: null,
  isLoading: true,
} as UniversityState

export const fetchUniversityTypes = createAsyncThunk(
  'university/fetchUniversityTypes',
  async () => {
    const data: any = await onGetUniversityTypes()

    return data.data.result.items
  }
)

export const fetchUniversities = createAsyncThunk(
  'university/fetchUniversities',
  async (param: any) => {
    const data: any = await onGetPagedAllUniversities(param)
    return data.data.result
  }
)

export const fetchUniversity = createAsyncThunk(
  'university/fetchUniversity',
  async (param: any) => {
    const data: any = await onGetUniversity(param)
    return data.data.result
  }
)

export const updateUniversity = createAsyncThunk(
  'university/updateUniversity',
  async (param: any) => {
    const data: any = await onUpdateUniversity(param)
    return data.data
  }
)

export const createUniversity = createAsyncThunk(
  'university/createUniversity',
  async (param: any) => {
    const data: any = await onCreateUniversity(param)
    return data.data
  }
)

export const deleteUniversity = createAsyncThunk(
  'university/deleteUniversity',
  async (param: any) => {
    const data: any = await onDeleteUniversity(param)
    return data.data
  }
)

const universitySlice = createSlice({
  name: 'university',
  initialState,
  reducers: {
    clearUniversities: (state) => {
      state.universities = []
    },
    clearUniversity: (state) => {
      state.university = null
    },
    activateLoading: (state) => {
      state.isLoading = true
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchUniversities.pending, (state: any) => {
      state.isLoading = true
    })
    builder.addCase(fetchUniversities.fulfilled, (state: any, action) => {
      state.universities = action.payload
      state.isLoading = false
    })
    builder.addCase(fetchUniversities.rejected, (state: any) => {
      state.isLoading = false
    })
    builder.addCase(fetchUniversity.fulfilled, (state: any, action) => {
      state.university = action.payload
    })
    builder.addCase(fetchUniversityTypes.fulfilled, (state: any, action) => {
      state.universityTypes = action.payload
    })
  },
})

export const {clearUniversities, clearUniversity, activateLoading} = universitySlice.actions

export default universitySlice.reducer
